module.exports = __webpack_public_path__ + "img/table-picnic.30f060c4.svg";